<template>
    <div class="mx-auto w-full max-w-7xl px-6 lg:px-8">
        <slot />
    </div>
</template>
